import React from "react";

function ToolpathOptimisation() {
  return <div>ToolpathOptimisation</div>;
}

export default ToolpathOptimisation;
